import { render, staticRenderFns } from "./WorkflowPosition.vue?vue&type=template&id=15292962&scoped=true"
import script from "./WorkflowPosition.vue?vue&type=script&lang=js"
export * from "./WorkflowPosition.vue?vue&type=script&lang=js"
import style0 from "./WorkflowPosition.vue?vue&type=style&index=0&id=15292962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15292962",
  null
  
)

export default component.exports